import fetch from "isomorphic-fetch"
import { browserHistory } from "react-router"
import { pendingTask, begin, end } from "react-redux-spinner"
import {
  NEW_NOTIFICATION_REQUEST,
  NEW_NOTIFICATION,
  NEW_NOTIFICATION_ERROR,
  NEW_NOTIFICATION_CONFIRMATION
} from "./types"

export function newNotification(notification) {
  console.log("CREATING NOTIFICATION: " + JSON.stringify(notification))
  return dispatch => {
    dispatch(createNotificationRequest())
    return fetch(`${process.env.REACT_APP_EF_API_URL}/notifications/new`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token")
      },
      body: JSON.stringify(notification)
    })
      .then(res => res.json())
      .then(json => {
        // todo check for error here please as onesignal will return 200 but with errors []
        dispatch(createNotificationSuccess(json.body))
      })
      .catch(error => dispatch(createNotificationFail(error)))
  }
}

export function createNotificationRequest() {
  //console.warn('Create Venue Request')
  return {
    type: NEW_NOTIFICATION_REQUEST,
    [pendingTask]: begin,
    payload: { fetching: true }
  }
}

export function createNotificationConfirmation(notification) {
  //console.log("notification actions: " + JSON.stringify(notification))
  const data = {
    loading: false,
    showConfirmation: true,
    notification
  }

  return {
    type: NEW_NOTIFICATION_CONFIRMATION,
    //[pendingTask]: end,
    payload: data
  }
}

export function createNotificationSuccess(notification) {
  browserHistory.push("/notifications/")
  return {
    type: NEW_NOTIFICATION,
    [pendingTask]: end,
    payload: notification
  }
}

export function createNotificationFail(error) {
  //console.error('Create venue failed: ' +error)
  return {
    type: NEW_NOTIFICATION_ERROR,
    [pendingTask]: end,
    payload: { error: error }
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/notification.js
 **/